export default __webpack_public_path__ + "static/media/img4.8bc6f076.svg";